import React from 'react'
import AllDataHeader from '../../../../Reuseable/AllDataHeader'
import LearnUserListTable from './LearnUserListTable'


const LearningUserList = () => {
    return (
        <>
            <AllDataHeader
                title="Learning Session User List"
                count="Zero"

            />

            <div className="row my-4">

                <div className="col-md-6 mb-3">
                    <div className="card card-bg p-2">
                        New Frame
                    </div>
                </div>
                <div className="col-md-6 mb-3 maxUserTable">
                    <LearnUserListTable />
                </div>
            </div>
        </>
    )
}

export default LearningUserList